
import MaskedInput from './masked-input.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'
import TabDefault from '~/components/ui/tab/tab-default.vue'

import { CALCULATOR_ELEMENT_PERIOD } from '@/constants/calculator'

export default {
  name: 'CalculatorBlock',
  components: {
    TabDefault,
    MaskedInput
  },
  mixins: [staticBlockMixin],
  inject: [
    'globalFormProvider',
    'setGlobalFormProvider',
    'setGlobalFormProviderProperties'
  ],
  data () {
    return {
      calculator: null,
      tabs: [], // активные табы калькулятора
      activeTab: 0, // активный таб
      activeCondition: 0, // активный тип калькулятора
      loanAmount: 0, // сумма кредита
      loanTerm: 0, // срок кредита
      percentageAmount: 0, // процентажная сумма кредита
      percentageTerm: 0, // процентажный срок кредита
      formTypeId: 0,
      customConditions: {},
      customRange: {
        minLoanAmount: null,
        maxLoanAmount: null,
        deadlineUntil: null,
        deadlineFrom: null
      },
      customCondition: {},
      conditionsList: [],
      iteratorIsUpper: true,
      prevTerm: 0,
      selectedCard: '',
      loanAmountChanged: false,
      conditionsToTabs: {},
      maskedInputTrigger: false
    }
  },
  async fetch () {
    try {
      //* Получаем активные табы по калькулятору
      const calculator = await this.$calculator.fetchCalculatorByCode(
        this.mainFields?.code?.value
      )

      //* Записываем данные калькулятора
      this.calculator = calculator

      //* Записываем их
      this.tabs = calculator.elements

      const activeTabIndex = calculator.elements?.findIndex(tab => tab?.name === this.mainFields?.formDefault?.value)
      this.activeTab = activeTabIndex !== -1 ? activeTabIndex : 0

      //* Высчитываем значения калькулятора
      this.calculateIndicators(true)

      if (this.calculator?.formTypeId) {
        this.formTypeId = this.calculator.formTypeId
        return
      }

      this.formTypeId =
        this.calculator?.typeCode !== 'vklady'
          ? this.$config?.app?.forms?.ids?.CALCULATOR_CREDIT
          : this.$config?.app?.forms?.ids?.CALCULATOR_VKLAD

      this.conditionsToTabs[this.activeTab] = this.activeCondition
      this.setFormSettings()
    } catch (error) {
      console.error(error)
    }
  },
  computed: {
    //* Обработчик расчета процентажной суммы кредита
    handlePercentageAmount () {
      // получаем шаг
      const range =
        this.calculator?.typeCode !== 'vklady'
          ? this.currentCondition.maxLoanAmount -
            this.currentCondition.minLoanAmount
          : this.customRange.maxLoanAmount - this.customRange.minLoanAmount

      // определяем текущее значение
      const currentValue =
        this.calculator?.typeCode !== 'vklady'
          ? this.loanAmount - this.currentCondition.minLoanAmount
          : this.loanAmount - this.customRange.minLoanAmount

      // высчитываем шаг
      return (currentValue / range) * 100
    },
    //* Обрбаотчик расчета процентажного срока кредита
    handlePercentageTerm () {
      // получаем шаг
      const range =
        this.calculator?.typeCode !== 'vklady'
          ? this.currentCondition.deadlineUntil -
            this.currentCondition.deadlineFrom
          : this.customRange.deadlineUntil - this.customRange.deadlineFrom

      // определяем текущее значение
      const currentValue =
        this.calculator?.typeCode !== 'vklady'
          ? this.loanTerm - this.currentCondition.deadlineFrom
          : this.loanTerm - this.customRange.deadlineFrom

      // высчитываем шаг
      return (currentValue / range) * 100
    },

    //* Текущий элемент калькулятора
    currentTab () {
      return this.tabs?.[this.activeTab] || {}
    },

    //* Выбираем период калькулятора
    currentPeriod () {
      return this.currentTab?.period || CALCULATOR_ELEMENT_PERIOD.MONTH
    },

    getTermDesciption () {
      switch (this.currentPeriod) {
        case CALCULATOR_ELEMENT_PERIOD.DAY:
          return 'дней'
        case CALCULATOR_ELEMENT_PERIOD.WEEK:
          return 'недель'
        default:
          return 'месяцев'
      }
    },

    //* Текущие типы калькулятора
    currentConditions () {
      return this.currentTab?.conditions || []
    },

    //* Текущий тип калькулятора
    currentCondition () {
      return (
        this.currentConditions?.[this.activeCondition] || {
          deadlineFrom: 0,
          deadlineUntil: 0,
          loanRate: 0,
          maxLoanAmount: 0,
          minLoanAmount: 0
        }
      )
    },

    //* Ежемесячный платеж
    monthlyPayment () {
      const S = this.loanAmount
      const P = this.currentCondition.loanRate / 100
      const N = this.loanTerm

      return this.calculateTruncate(
        (((S * P) / 12) * Math.pow(1 + P / 12, N)) /
          (Math.pow(1 + P / 12, N) - 1)
      )
    },

    //* Расчет вклада
    contribution () {
      const startDate = new Date()
      const endDate = new Date(startDate)

      switch (this.currentPeriod) {
        case CALCULATOR_ELEMENT_PERIOD.DAY:
          endDate.setDate(startDate.getDate() + this.loanTerm)
          break
        case CALCULATOR_ELEMENT_PERIOD.WEEK:
          endDate.setDate(startDate.getDate() + this.loanTerm * 7)
          break
        default:
          endDate.setMonth(startDate.getMonth() + this.loanTerm)
          break
      }

      const currentYear = startDate.getFullYear()
      const startOfYear = new Date(currentYear, 0, 1)
      const endOfYear = new Date(currentYear + 1, 0, 1)

      const P = this.loanAmount
      const I = this.customCondition.loanRate
      const T = Math.floor((+endDate - +startDate) / (1000 * 60 * 60 * 24))
      const K = Math.floor((+endOfYear - +startOfYear) / (1000 * 60 * 60 * 24))

      return this.calculateTruncate(P + (P * I * T) / K / 100)
    }
  },
  watch: {
    //* Следим за изменением стоимости кредитане
    loanAmount: {
      handler (newValue) {
        if (newValue) {
          this.loanAmountChangeHandler(newValue)
          this.setGlobalFormProviderProperties({
            loanAmount: newValue,
            loanTerm: this.loanTerm
          })
        }
      },
      immediate: true
    },

    //* Следим за изменением срока кредита
    loanTerm: {
      handler (newValue) {
        if (newValue) {
          this.percentageTerm = this.handlePercentageTerm
          this.setGlobalFormProviderProperties({
            loanAmount: this.loanAmount,
            loanTerm: newValue
          })
        }
      },
      immediate: true
    },

    //* Следим за изменением типа калькулятора
    currentCondition: {
      handler () {
        this.calculateIndicators()
        this.loanAmountChangeHandler(this.loanAmount)
        this.percentageTerm = this.handlePercentageTerm
        if (this.currentCondition) {
          const newLoanAmount = this.currentCondition.minLoanAmount
          const newLoanTerm = this.currentCondition.deadlineFrom
          this.$set(this, 'loanAmount', newLoanAmount)
          this.$set(this, 'loanTerm', newLoanTerm)
          this.setGlobalFormProviderProperties({
            loanAmount: newLoanAmount,
            loanTerm: newLoanTerm,
            typeOfCard: (this.calculator?.typeCode !== 'credit' ? this.selectedCard : this.currentTab.name)
          })
        }
      },
      deep: true
    },
    watch: {
      '$route.query.form' (val) {
        if (!val) { this.selectedCard = '' }
      }
    },
    activeTab: {
      handler () {
        if (this.loanAmountChanged) { return }
        this.calculateIndicators(false, true)
      },
      immediate: true
    }
  },
  mounted () {
    // Устанавливаем значения только если они определены
    if (this.loanAmount && this.loanTerm) {
      this.setGlobalFormProviderProperties({
        typeId: this.formTypeId,
        loanAmount: this.loanAmount,
        loanTerm: this.loanTerm,
        typeOfCard: (this.calculator?.typeCode !== 'credit' ? this.selectedCard : this.currentTab.name),
        isLong: (this.$attrs?.['is-long'] || this.blockParams?.isLong),
        formDefault: this.mainFields?.formDefault?.value
      })
    }
  },

  methods: {
    setFormSettings () {
      // Устанавливаем значения только если они определены
      if (this.loanAmount && this.loanTerm) {
        this.setGlobalFormProviderProperties({
          typeId: this.formTypeId,
          loanAmount: this.loanAmount,
          loanTerm: this.loanTerm,
          typeOfCard: (this.calculator?.typeCode !== 'credit' ? this.selectedCard : this.currentTab.name),
          isLong: (this.$attrs?.['is-long'] || this.blockParams?.isLong),
          formDefault: this.mainFields?.formDefault?.value
        })
      }
    },

    openModal () {
      this.selectedCard = this.calculator.name
      this.setFormSettings()
      this.$router.push({ query: { ...this.$route.query, form: this.formTypeId } })
    },

    chooseTab (index) {
      this.activeTab = index
      this.activeCondition = this.conditionsToTabs?.[this.activeTab] || 0
      this.conditionsToTabs[index] = this.activeCondition
    },
    chooseCondition (index) {
      this.activeCondition = index
      this.conditionsToTabs[this.activeTab] = index
    },
    detectUserInput () {
      this.loanAmountChanged = true
    },
    loanAmountChangeHandler (newValue: number) {
      this.percentageAmount = this.handlePercentageAmount

      if (!newValue || this.calculator.typeCode !== 'vklady') {
        return
      }

      const conditions = this.conditionsList
        .filter(
          el => newValue >= el.minLoanAmount && newValue <= el.maxLoanAmount
        )
        .sort((a, b) => a.deadlineFrom - b.deadlineFrom)

      const condition =
        conditions.find(el => el.deadlineFrom === this.loanTerm) ||
        conditions?.[0]

      this.customCondition = condition

      if (this.loanTerm < condition.deadlineFrom) {
        this.loanTerm = condition.deadlineFrom
      }

      if (this.loanTerm > condition.deadlineUntil) {
        this.loanTerm = condition.deadlineUntil
      }
    },

    changeTerm ($event) {
      const value = +$event.target.value

      if (value === this.prevTerm) {
        return
      }

      this.iteratorIsUpper = value > this.prevTerm

      this.prevTerm = value

      if (
        !value ||
        this.calculator.typeCode !== 'vklady' ||
        this.conditionsList.some(el => el.deadlineFrom !== el.deadlineUntil)
      ) {
        this.loanTerm = value
        return
      }

      const ranges = this.conditionsList.map(el => el.deadlineFrom)

      function findRange (num, arr) {
        // Сортировка массива по возрастанию
        const sortedArr = [...arr].sort((a, b) => a - b)

        // Поиск индекса числа, большего или равного заданному
        const index = sortedArr.findIndex(item => item >= num)

        // Если индекс не найден, вернем последний элемент и null
        if (index === -1) {
          return [
            sortedArr[sortedArr.length - 1],
            sortedArr[sortedArr.length - 1]
          ]
        }

        const defIndex = sortedArr[index]
        const indexOne = sortedArr[index - 1] || defIndex
        const indexTwo = sortedArr[index + 1] || defIndex

        return [
          this.iteratorIsUpper ? indexOne : defIndex,
          this.iteratorIsUpper ? defIndex : indexTwo
        ]
      }

      const range = findRange.call(this, value, ranges)

      if (this.iteratorIsUpper) {
        this.loanTerm = range[1]
      } else {
        this.loanTerm = range[0]
      }

      const conditions = this.conditionsList
        .filter(el => el.deadlineFrom === this.loanTerm)
        .sort((a, b) => a.minLoanAmount - b.minLoanAmount)

      const condition =
        conditions?.find(
          el =>
            this.loanAmount >= el.minLoanAmount &&
            this.loanAmount <= el.maxLoanAmount
        ) || conditions?.[0]

      this.customCondition = condition

      if (this.loanAmount < condition.minLoanAmount) {
        this.loanAmount = condition.minLoanAmount
      }

      if (this.loanAmount > condition.maxLoanAmount) {
        this.loanAmount = condition.maxLoanAmount
      }
      this.setFormSettings()
    },
    changeInputCount ($event) {
      if (!$event?.target?.value?.length) {
        $event.target.value = 0
        return
      }
      if ($event?.target?.value?.length > 9) {
        $event.target.value = $event.target.value.slice(0, 9)
        return
      }
      if ($event?.target?.value?.startsWith('0')) {
        $event.target.value = $event.target.value.slice(1)
      }
    },
    //* Обработка высчитывания значений калькулятора
    calculateIndicators (mounted = false, toDefault = false) {
      if (this.calculator?.typeCode !== 'vklady') {
        this.minMaxAmountAndTerm(this.currentCondition, toDefault)
        return
      }

      if (mounted) {
        const element = this.calculator?.elements?.[0]

        for (const condition of element?.conditions) {
          this.customConditions[condition.name] = condition
        }

        for (const typeOfCondition in this.customConditions) {
          const condition = this.customConditions[typeOfCondition]

          this.conditionsList.push(condition)

          if (
            this.customRange.minLoanAmount === null ||
            condition.minLoanAmount < this.customRange.minLoanAmount
          ) {
            this.customRange.minLoanAmount = condition.minLoanAmount
          }

          if (
            this.customRange.deadlineFrom === null ||
            condition.deadlineFrom < this.customRange.deadlineFrom
          ) {
            this.customRange.deadlineFrom = condition.deadlineFrom
          }

          if (
            this.customRange.maxLoanAmount === null ||
            condition.maxLoanAmount > this.customRange.maxLoanAmount
          ) {
            this.customRange.maxLoanAmount = condition.maxLoanAmount
          }

          if (
            this.customRange.deadlineUntil === null ||
            condition.deadlineUntil > this.customRange.deadlineUntil
          ) {
            this.customRange.deadlineUntil = condition.deadlineUntil
          }
        }

        this.conditionsList.sort((a, b) => a.deadlineFrom - b.deadlineFrom)

        if (
          this.conditionsList.every(
            condition =>
              condition.minLoanAmount === this.customRange.minLoanAmount
          )
        ) {
          const condition = this.conditionsList.find(
            el => el.deadlineFrom === this.customRange.deadlineFrom
          )

          this.customCondition = condition
        } else {
          const condition = this.conditionsList.find(
            el => el.minLoanAmount === this.customRange.minLoanAmount
          )

          this.customCondition = condition
        }
        this.minMaxAmountAndTerm(this.customCondition)
      }
    },

    minMaxAmountAndTerm (value: any, toDefault = false) {
      if (toDefault) {
        this.$set(this, 'loanAmount', value.minLoanAmount)
        this.$set(this, 'loanTerm', value.deadlineFrom)
        return
      }
      this.$set(this, 'loanAmount', this.limitByMinMax(this.loanAmount, value.minLoanAmount, value.maxLoanAmount))
      this.$set(this, 'loanTerm', this.limitByMinMax(this.loanTerm, value.deadlineFrom, value.deadlineUntil))
    },

    limitByMinMax (value: number, min: number, max: number) {
      return Math.min(Math.max(value, min), max)
    },

    //* Обработка обрезания лишних нулей
    calculateTruncate (number) {
      return Math.floor(number * 100) / 100
    },

    //* Обработка изменения значения с учетом максимального и минимального числа
    changeInput ({ value, min, max }) {
      let result = value
      if (value > max) {
        result = max
      }

      if (value < min) {
        result = min
      }

      this.$refs.maskedInput?.validateValues()

      return result
    }
  }
}
